import React from "react";

export default function InterdicaoDetalhesLocomotivasFields({
  Section,
  ReadOnlyField,
  formatDate,
  interdicao,
  resolveValue,
}) {
  return (
    <Section title="Operação">
      <div className="interdDet-grid interdDet-grid--3">
        <ReadOnlyField label="Data" value={formatDate(interdicao.dataInicio)} />
        <ReadOnlyField label="Horário início" value={interdicao.horaInicio || "-"} />
        <ReadOnlyField label="Trem" value={resolveValue("trem") || "-"} />
        <ReadOnlyField
          label="Seção de Bloqueio"
          value={resolveValue("sb", "sbParada") || "-"}
        />
        <ReadOnlyField label="KM" value={resolveValue("kmInicial", "km") || "-"} />
        <ReadOnlyField label="Nº Ativo" value={resolveValue("ativo", "numeroAtivo") || "-"} />
        <ReadOnlyField label="Frota" value={resolveValue("frota") || "-"} />
        <ReadOnlyField
          label="Tipo de operação"
          value={resolveValue("tipoOperacao", "tipo_operacao") || "-"}
        />
        <ReadOnlyField
          label="Posto de origem do SOS"
          value={resolveValue("postoOrigemSos", "posto_origem_sos") || "-"}
        />
        <ReadOnlyField
          label="Mecânico acionado"
          value={resolveValue("mecanicoAcionado", "mecanico_acionado") || "-"}
        />
        <ReadOnlyField
          label="Nível de Acionamento"
          value={resolveValue("nivelAcionamento", "nivel_acionamento") || "-"}
        />
        <ReadOnlyField label="Motivo" value={resolveValue("motivo") || "-"} />
        <ReadOnlyField
          label="Obs."
          value={resolveValue("observacao") || "-"}
          wide
          multiline
        />
      </div>
    </Section>
  );
}
